import React, { useState } from 'react';
import { Box, Typography, Dialog, Button } from '@mui/material';
import { ColorsV2 } from 'app/constants/color';
import PrivacyDropdown from '../privacyDropDown';
import { Buttons } from 'app/constants/sizing';
import { useTranslation } from 'react-i18next';

const CreatePolicyModal = ({ setOpen, handleCreatePolicy }) => {
  const [selectedOption, setSelectedOption] = useState('default');
  const [info, setInfo] = useState({ name: '', description: '' });

  const handleStart = () => {
    handleCreatePolicy({ name: info.name, templateId: selectedOption });
    setOpen(false);
  };

  const { t } = useTranslation('translation', { keyPrefix: 'policy_manager' });

  return (
      <Dialog maxWidth={'100%'} open={true} onClose={() => setOpen(false)}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            width: '20vw',
            padding: '20px',
            background: ColorsV2.secondary,
            overflowY: 'auto',
            overflowX: 'hidden',
            backgroundColor: ColorsV2.secondary,
            border: `2px solid ${ColorsV2.outline}`,
            borderRadius: '0px',
          }}
        >
          <Typography variant='h5' sx={{ color: ColorsV2.textInfo}}>{t('create_policy_menu_header')}</Typography>
          <Typography variant='body2' sx={{ color: ColorsV2.acent, display: 'box', borderRadius: '4px', padding: '20px', backgroundColor: ColorsV2.primary}}>
            {t('create_policy_menu_warning')}
          </Typography>
          <Typography variant='body1' sx={{ color: ColorsV2.white}}>
            {t('create_policy_menu_description')}
          </Typography>
          <Box sx={{ my: '15px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
            <PrivacyDropdown
              name='privacy'
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
              info={info}
              setInfo={setInfo}
            />
            <Typography sx={{
              width: '100%',
              color: ColorsV2.textInfo,
            }}>
              {info.description}
            </Typography>
            <Button
              name='IconButton'
              disabled={selectedOption === 'default'}
              onClick={handleStart}
              sx={{
                ...Buttons.baseStyle.primaryButtonHighPriority,
                width: '120px',
                height: '40px',
                alignSelf: 'flex-end'
              }}
            >
              {t('start')}
            </Button>
          </Box>
        </Box>
      </Dialog>
  );
};

export default CreatePolicyModal;
